/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementGtagForDomainEnvOptions, FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsToJSON, } from './FxIdDomainSettingsAdvertisementGtagForDomainEnvOptions';
export function FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvFromJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementGtagForDomainEnvOptions(json)) {
        return FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvToJSON(json) {
    return FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnvToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementGtagForDomainEnvOptions(value)) {
        return FxIdDomainSettingsAdvertisementGtagForDomainEnvOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementGtagForDomainOptionsEnv.js.map